import { ALL_DATA_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  alldatareport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const alldatareportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ALL_DATA_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case ALL_DATA_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        alldatareport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case ALL_DATA_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default alldatareportReducer;
